// 引入公共模块
import { 
  initActivityBannerHandler,
  mergeParams,
  addParamsToLinksHandler,
  initUrlParamsHandler,
  pageJumpHandler,
  pageJumpBlankHandler,
  initScrollHandler,
  initNavBarHandler,
  navSolutionsTabHandler
} from './common.js';

// 命名空间模式
const App = {
  init() {
    initActivityBannerHandler(); // 专题横幅
    addParamsToLinksHandler(mergeParams()); //为链接添加参数
    pageJumpHandler(); //页面跳转
    pageJumpBlankHandler(); //页面跳转(新窗口打开)
    initScrollHandler(); // 页面滚动处理
    initNavBarHandler();
    navSolutionsTabHandler();
    this.navTabHandler();
  },
  navTabHandler() {

    const $navItem = $('.category-nav-item');
    const offset = 160; // 滚动顶部留白偏移量

    $navItem.on('click', (e)=> {
      // 阻止默认行为、阻止冒泡
      e.preventDefault();
      // 获取当前点击按钮
      const currentBtn = $(e.currentTarget);
      
      // 切换选中样式
      currentBtn.addClass('active').siblings().removeClass('active');

      const target = currentBtn.attr('data-target');

      // 全部应用 → 回到顶部
      if (target === 'all') {
        $('html, body').stop(true, false).animate({
          scrollTop: 0
        }, 200);
        return;
      }

      // 滑动到对应模块
      const targetEl = $(`#section-${target}`);
      if (targetEl.length) {
        $('html, body').stop(true, false).animate({
          scrollTop: targetEl.offset().top - offset
        }, 200);
      }
    })
  }
};

// 文档加载后初始化
$(function () {
  App.init();
});
